import Vue from 'vue';

import Element from 'element-ui';
import i18n from '@/lang'; // internationalization
import VueAxios from 'vue-axios';
import ECharts from 'vue-echarts';
import '@/utils/global-extends';
import '@/assets/style/element-theme-chalk/index.css';
//辅助
import axios from './utils/axios';

Vue.component('v-chart', ECharts);
Vue.use(VueAxios, axios);
Vue.use(Element, {
    size: localStorage.getItem('size') || 'medium', // set element-ui default size
    i18n: (key, value) => i18n.t(key, value)
});

import * as filters from '@/filters'; // global filters
import setVm from '@/utils/setVm';
import '@/assets/style/index.less'; // global css
import '@/icons'; // icon

setVm(Vue);
Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key]);
});

import App from '@/App';

import store from '@/store';

import router from '@/router';


Vue.config.productionTip = false;

new Vue({
    el: '#app',
    store,
    router,
    i18n,
    render: h => h(App)
});